export const applyMoneyMask = (value: string): string => {
    const digitsOnly = value.replace(/\D/g, '');
    if (!digitsOnly) return '';

    const num = parseInt(digitsOnly, 10) / 100;
    return num.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export const parseMoney = (value: string): number => {
    if (!value) return 0;
    const digitsOnly = value.replace(/\D/g, '');
    if (!digitsOnly) return 0;
    const num = parseInt(digitsOnly, 10) / 100;
    return Math.round(num * 100) / 100;
};
